import { createFileRoute, redirect } from '@tanstack/react-router'
import { PackagesListPage } from '@/pages/Packages/PackagesListPage'
import { useAuthStore } from '@/store/authStore'
import { canAccessRoute } from '@/lib/roles'

export const Route = createFileRoute('/_authenticated/packages')({
  component: PackagesListPage,
  beforeLoad: () => {
    const role = useAuthStore.getState().user?.role
    if (!canAccessRoute(role, '/packages')) {
      throw redirect({ to: '/' })
    }
  },
})
